import React from "react";
import WaveXchangeLogo from "../../../assets/images/wavexchange-logo-color.svg";
import WaveXchangeLogoSmall from "../../../assets/images/wavexchange-small-icon.svg";
import EditIcon from "../../../assets/images/edit-icon.svg";
import { areYouSure, wrapInTooltip } from "../../../utils/methods";
import Button from "../../DesignSystem/button";
import { ManageLeasedPortsType } from "../../PortDetails/useManageLeasedPorts";
import { PortDetails } from "../../PortDetails";
interface waveXchangeProps {
  port: any;
  on_net: boolean;
  handleRequestVerification: () => void;
  refresh: () => void;
}

const WaveXchangeButton: React.FC<waveXchangeProps> = ({ port, on_net, handleRequestVerification, refresh }) => {
  const style = { height: "32px", display: "flex", justifyContent: "center" };
  const organizationId = Number(localStorage.getItem("org_id") || -1);
  if (!on_net) return <div className="flex">Node Offline</div>;
  // Leased case
  if (port.ne_leased_organization && port.ne_leased_organization === organizationId) {
    if (port.verified) {
      return <PortDetails nrId={port.nr_id} refreshIndex={refresh} buttonType="edit_connect" />;
    } else {
      return <PortDetails nrId={port.nr_id} refreshIndex={refresh} buttonType="add_connect" />;
    }
  }

  if (port.verified) {
    return wrapInTooltip(
      <div style={style}>
        <img src={WaveXchangeLogo} alt="WaveXchange logo" />
      </div>,
      "Port is on WaveXchange",
      "bottom"
    );
  }
  if (port.requested_verification) {
    return (
      <div style={style} className="d-btn">
        <Button
          variant="green"
          className="h-32"
          node={
            <div className="flex">
              <img src={WaveXchangeLogoSmall} alt="wavexchange pending" />
              Pending...
            </div>
          }
          disabled
        />
      </div>
    );
  }
  return (
    <div style={style} className="d-btn">
      <Button
        onClick={() => areYouSure(() => handleRequestVerification(), `Move ${port.port_description} ${port.port_name} to WaveXchange?`)}
        variant="green"
        className="h-32"
        // loading={moveToWaveXchange.loading}
        node={
          <div className="flex">
            Move to
            <img src={WaveXchangeLogoSmall} alt="move to wavexchange" />
          </div>
        }
      />
    </div>
  );
};

export default WaveXchangeButton;
